import React from "react";
import AppRouter from "./routes/AppRouter";

const App = (): React.ReactElement => {

  return <AppRouter />

};

export default App;